import React from 'react';

// touch context
export const IsTouchEnabledContext = React.createContext({ isTouchDevice: true });
export const IsTouchEnabledConsumer = IsTouchEnabledContext.Consumer;
